const allLenders = [
    {
      slug: 'ava',
      rateSlug: 'avant',
      name: 'Avant',
      minTerm: 1,
      maxTerm: 5,
      minAmount: 1000,
      maxAmount: 35000,
      minCreditScore: 500,
    },
    {
      slug: 'axos',
      rateSlug: 'axos',
      name: 'Axos',
      minTerm: 1,
      maxTerm: 5,
      minAmount: 5000,
      maxAmount: 35000,
      minCreditScore: 720,
    },
    {
      slug: 'marlette',
      rateSlug: 'marlette',
      name: 'Best Egg',
      minTerm: 3,
      maxTerm: 5,
      minAmount: 5000,
      maxAmount: 35000,
      minCreditScore: 640,
    },
    {
      slug: 'frp',
      rateSlug: 'freedom-plus',
      name: 'FreedomPlus',
      minTerm: 2,
      maxTerm: 5,
      minAmount: 10000,
      maxAmount: 40000,
      minCreditScore: 640,
    },
    {
      slug: 'ldc',
      rateSlug: 'lending-club',
      name: 'LendingClub',
      minTerm: 3,
      maxTerm: 5,
      minAmount: 1000,
      maxAmount: 40000,
      minCreditScore: 500,
    },
    {
      slug: 'lending-point',
      rateSlug: 'lending-point',
      name: 'LendingPoint',
      minTerm: 2,
      maxTerm: 4,
      minAmount: 2000,
      maxAmount: 25000,
      minCreditScore: 585,
    },
    {
      slug: 'lightstream',
      rateSlug: 'lightstream',
      name: 'LightStream',
      minTerm: 2,
      maxTerm: 7,
      minAmount: 1000,
      maxAmount: 100000,
      minCreditScore: 640,
    },
    {
      slug: 'marcus',
      rateSlug: 'marcus',
      name: 'Marcus by Goldman Sachs',
      minTerm: 2,
      maxTerm: 6,
      minAmount: 3500,
      maxAmount: 40000,
      minCreditScore: 640,
    },
    {
      slug: 'payoff',
      rateSlug: 'payoff',
      name: 'Payoff',
      minTerm: 2,
      maxTerm: 5,
      minAmount: 5000,
      maxAmount: 35000,
      minCreditScore: 640,
    },
    {
      slug: 'pro',
      rateSlug: 'prosper',
      name: 'Prosper',
      minTerm: 3,
      maxTerm: 5,
      minAmount: 2000,
      maxAmount: 40000,
      minCreditScore: 500,
    },
    {
      slug: 'sofi',
      rateSlug: 'sofi',
      name: 'Sofi',
      minTerm: 2,
      maxTerm: 7,
      minAmount: 5000,
      maxAmount: 100000,
      minCreditScore: 650,
    },
    {
      slug: 'upgrade',
      rateSlug: 'upgrade',
      name: 'Upgrade',
      minTerm: 3,
      maxTerm: 5,
      minAmount: 10000,
      maxAmount: 50000,
      minCreditScore: 640,
    },
    {
      slug: 'ups',
      rateSlug: 'upstart',
      name: 'Upstart',
      minTerm: 3,
      maxTerm: 5,
      minAmount: 1000,
      maxAmount: 50000,
      minCreditScore: 500,
    },
  ],
  OMITTED_LENDER_SLUGS = [
    'marcus', // Marcus
  ],
  availableLenders = allLenders.filter(lender => !OMITTED_LENDER_SLUGS.includes(lender.slug))

export { allLenders, availableLenders }
